import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/arrow-full.svg';
import { Icon } from '../Icon/Icon';
const ArrowFullIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
export const ArrowFullUpIcon = (props) => <ArrowFullIcon direction="up" {...props}/>;
export const ArrowFullDownIcon = (props) => <ArrowFullIcon direction="down" {...props}/>;
export const ArrowFullLeftIcon = (props) => <ArrowFullIcon direction="left" {...props}/>;
export const ArrowFullRightIcon = (props) => <ArrowFullIcon direction="right" {...props}/>;
